import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import TopExportCSV from "../../../../componentsTopsa/exportCSV/TopExportCSV";
import acc from 'accounting'

export default class UrzadRaportCennikowTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            wszystkieKolumnyEksport:[
                {value: "nazwa", label: 'Nazwa'},
                {value: "cena_brutto", label: 'Cena brutto'},
                {value: "cena_37", label: 'Cena 37%'},
                {value: "cena_49", label: 'Cena 49%'},
                {value: "cena_51", label: 'Cena 51%'},
                {value: "cena_78", label: 'Cena 78%'},
                {value: "cena_93", label: 'Cena 93%'},
                {value: "cena_95", label: 'Cena 95%'},
                {value: "nr_progu", label: 'Przedział'},
            ],
            kolumnyDoExportuDefault:[
                {value: "nazwa", label: 'Nazwa'},
                {value: "cena_brutto", label: 'Cena brutto'},
                {value: "cena_37", label: 'Cena 37%'},
                {value: "cena_49", label: 'Cena 49%'},
                {value: "cena_51", label: 'Cena 51%'},
                {value: "cena_78", label: 'Cena 78%'},
                {value: "cena_93", label: 'Cena 93%'},
                {value: "cena_95", label: 'Cena 95%'},
                {value: "nr_progu", label: 'Przedział'},
            ],
        };
        this.formatProgi=this.formatProgi.bind(this)

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextprops){
    }


    formatNazwa(cell,row){
        if(row.czy_prog){
            return <span style={{fontWeight:'bold', background:'#ddd', display:'block', padding:'3px', fontSize:'12px'}}>Przedział {cell} km</span>
        }
        else{
            return cell
        }
    }

    formatCena(cell,row){
        if(row.czy_prog){
            return <span style={{fontWeight:'bold', background:'#ddd', display:'block', padding:'3px', fontSize:'12px'}}>{acc.formatMoney(cell)}</span>
        }
        else{
            return acc.formatMoney(cell)
        }
    }

    formatProgi(cell,row){
        let prog = this.props.data.find(p=>Boolean(p.czy_prog) && p.nr_progu === cell)

        if(row.czy_prog){
            return <span style={{fontWeight:'bold', background:'#ddd', display:'block', padding:'3px', fontSize:'12px'}}>&nbsp;</span>
        }
        else{
            return <span>{cell} <span style={{marginLeft:'5px', color:'grey', fontSize:'12px'}}>{Boolean(prog)?<span>({prog.nazwa} km)</span>:''}</span></span>
        }
    }

    render() {
        const options = {
            noDataText: 'Brak pasujących rekordów',
        };

        let progi = {
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13",
            14: "14",
            15: "15",
        }

        return (
            <div>
                <div>
                    <TopExportCSV daneRest={this.props.data} wszystkieKolumny={this.state.wszystkieKolumnyEksport} kolumnyDoExportu={this.state.kolumnyDoExportuDefault}/>
                </div>
                <div>
                    <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                        Ilość wyszukanych kombinacji: {Boolean(this.props.data) ? this.props.data.length : 0}
                    </div>
                </div>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    hover
                    >
                        <TableHeaderColumn dataField='nazwa' isKey
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg9} tdStyle={tabgrid.tg9}
                                           dataFormat={this.formatNazwa}
                        >Nazwa</TableHeaderColumn>
                        <TableHeaderColumn dataField='cena_brutto'
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Cenna brutto</TableHeaderColumn>
                        <TableHeaderColumn dataField='cena_37'
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Cena 37%</TableHeaderColumn>
                        <TableHeaderColumn dataField='cena_49'
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Cena 49%</TableHeaderColumn>
                        <TableHeaderColumn dataField='cena_51'
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Cena 51%</TableHeaderColumn>
                        <TableHeaderColumn dataField='cena_78'
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Cena 78%</TableHeaderColumn>
                        <TableHeaderColumn dataField='cena_93'
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Cena 93%</TableHeaderColumn>
                        <TableHeaderColumn dataField='cena_95'
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Cena 95%</TableHeaderColumn>
                        <TableHeaderColumn dataField='nr_progu'
                                           expandable={false}
                                           filter={{type: 'SelectFilter', options: progi, selectText: 'Przedział...', condition: 'like'}}
                                           formatExtraData={progi}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatProgi}
                        >Przedział</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/raport_cennikow/components/UrzadRaportCennikowTable.js